import {
  Badge,
  Box,
  CircularProgress,
  CircularProgressLabel,
  Flex,
  IconButton,
  Text,
} from "@chakra-ui/react";
import { FiMoreHorizontal } from "react-icons/fi";
import { goalChip, yearlyLine } from "../../helpers/goals";

/**
 * Compact: ring with percentage, count, and an ahead/behind line.
 */
const YearlyGoalCard = ({ goal, onManage }) => {
  const progress = goal.progress || {};
  const percent = Math.min(Math.max(Number(progress.percent) || 0, 0), 100);
  const chip = goalChip(goal);
  const delta = Number(progress.delta) || 0;
  const isPaused = goal.status === "paused";

  return (
    <Flex
      align="center"
      aria-label={goal.title}
      bg="#171C2D"
      border="1px solid"
      borderColor="#30384E"
      borderRadius="xl"
      gap="4"
      mb="3"
      opacity={isPaused ? 0.65 : 1}
      px={{ base: 4, md: 5 }}
      py={{ base: 4, md: 5 }}
      role="group"
    >
      <CircularProgress
        color="red.500"
        size="88px"
        thickness="8px"
        trackColor="#2E3A59"
        value={percent}
      >
        <CircularProgressLabel fontSize="lg" fontWeight="bold">
          {Math.round(percent)}%
        </CircularProgressLabel>
      </CircularProgress>
      <Box flex="1" minW="0">
        <Text fontSize="xl" fontWeight="bold" lineHeight="1.2">
          {goal.title}
        </Text>
        <Text color="gray.400" fontSize="sm" mt="1">
          {progress.completed ?? 0} of {progress.target ?? goal.targetCount}{" "}
          comics
        </Text>
        <Text
          color={
            isPaused
              ? "gray.400"
              : delta > 0
              ? "green.300"
              : delta < 0
              ? "yellow.300"
              : "gray.300"
          }
          fontSize="sm"
          mt="1"
        >
          {yearlyLine(goal)}
        </Text>
      </Box>
      {!!chip && isPaused && (
        <Badge borderRadius="full" colorScheme={chip.colorScheme} px="3" py="1">
          {chip.label}
        </Badge>
      )}
      {!!onManage && (
        <IconButton
          aria-label={`Manage ${goal.title}`}
          icon={<FiMoreHorizontal />}
          onClick={() => onManage(goal)}
          size="sm"
          variant="ghost"
          color="gray.400"
        />
      )}
    </Flex>
  );
};

export default YearlyGoalCard;
